import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { Alert, Card, CardBody, CardTitle } from "reactstrap";
import BloodCollectionOrderForm, {
  BLOOD_COLLECTION_ORDER_FORM_MODE,
  BLOOD_COLLECTION_ORDER_FORM_ROLE_MODE,
} from "../BloodCollectionOrderForm";
import { useCheckRole, useDetailOrder } from "hooks";
import { Link, useParams } from "react-router-dom";
import OrderImageList from "./OrderImageList";
import DetailLoading from "./DetailLoading";
import OrderHistoryList from "./OrderHistoryList";
import Toolbar from "./Toolbar";
const DetailBloodCollectionOrderPage = () => {
  const { t } = useTranslation(["bloodOrder"]);
  const { isHubAdmin, isLogAdmin } = useCheckRole();
  let { orderId } = useParams();
  const {
    data: orderDetail,
    refetch: onDetailOrder,
    isLoading: orderDetailLoading,
  } = useDetailOrder({
    orderId: orderId,
  });

  useEffect(() => {
    if (orderId) {
      onDetailOrder();
    }
  }, [orderId]);

  return (
    <div
      className="page-content"
      style={{
        minHeight: "102vh",
      }}
    >
      <MetaTags>
        <title>{t("title.detail")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={t("title.detail")}
          breadcrumbItems={[
            { name: t("title.manager") },
            { name: t("title.detail") },
          ]}
        />
        {Boolean(orderDetail?.is_reminder_order || 0) && (
          <Alert color="primary">
            Đơn được tạo tự động.
            <Link
              className="alert-link mx-2"
              to={`/collection-order/${orderDetail?.order_source_id}`}
              rel="noreferrer"
              target="_blank"
            >
              Xem đơn gốc
            </Link>
          </Alert>
        )}
        {orderDetail && (
          <Card>
            <CardBody>
              <Toolbar
                orderDetail={orderDetail}
                refetchDetail={onDetailOrder}
              />
            </CardBody>
          </Card>
        )}
        <Card>
          <CardBody
            style={{
              position: "relative",
            }}
          >
            <BloodCollectionOrderForm
              roleMode={
                isHubAdmin || isLogAdmin
                  ? BLOOD_COLLECTION_ORDER_FORM_ROLE_MODE.ADMIN
                  : BLOOD_COLLECTION_ORDER_FORM_ROLE_MODE.SALE
              }
              formMode={BLOOD_COLLECTION_ORDER_FORM_MODE.DETAIL}
              orderDetail={orderDetail}
            />
            {orderDetailLoading && <DetailLoading />}
          </CardBody>
        </Card>
        {orderDetail && (
          <>
            <Card>
              <CardBody>
                <CardTitle>Hình ảnh đơn hàng</CardTitle>
                <OrderImageList orderId={orderId} />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <CardTitle>Lịch sử đơn hàng</CardTitle>
                <OrderHistoryList orderId={orderId} />
              </CardBody>
            </Card>
          </>
        )}
      </div>
    </div>
  );
};

export default DetailBloodCollectionOrderPage;
